module.exports = __webpack_public_path__ + "static/img/duxue.2675f7ed.png";